'use client';

import { CatButton } from 'blocks-nextjs/blocks-react/components/Button';
import { useTranslations } from 'next-intl';
import { capitalizeText, isEmpty } from '@cat-ecom/common/utils/commonUtils';
import { usePriceAndAvailabilityQuery } from 'services/priceAvailability/use-query-price-availability';
import { getPartsList } from 'services/priceAvailability/utils';
import cx from 'classnames';
import styles from '../part-price.module.scss';
import { useBreakpoint } from '@cat-ecom/pcc-components';
import { PAGE_BREAKPOINTS } from 'constants/common';
import { checkIsRiyal, getRiyalFormattedPrice } from 'app/[lang]/[esite]/utils/paymentUtils';

const PartGenuinePrice = ({
  remanType,
  storeId,
  langId,
  isUserStoreSelected,
  isPccReleaseRemanReplacement = false,
  currency = '', 
  isRTL = false,
  currencyLdFeatureFlag = false
}) => {
  const t = useTranslations();
  const isMd = useBreakpoint(PAGE_BREAKPOINTS.MD);
  const isMobile = !isMd;
  const partsList = getPartsList([remanType]);
  const { data: priceData } = usePriceAndAvailabilityQuery({
    storeId,
    langId,
    partsList
  });
  const { items: priceItems = [] } = priceData ?? {};
  const genuinePartPrice = priceItems[0];
  const discountedPrice = !isEmpty(genuinePartPrice)
    ? genuinePartPrice.discountedPrice
    : '';
  const genuineDiscountedPrice = !isEmpty(genuinePartPrice)
    ? genuinePartPrice.discountedPrice
    : '';
  const showUpsellPrice =
    !!discountedPrice && discountedPrice !== priceData?.formattedZeroPrice;

  const genuinePartLinkTitle =
    isPccReleaseRemanReplacement && isMobile
      ? capitalizeText(t('CAT_GENUINE'))
      : t('CAT_GENUINE');

  const genuinePartLink = remanType && genuinePartLinkTitle;
  const toShowGenuinePartLink = showUpsellPrice && genuinePartLink;
  const saudiCurrencySymbol = currencyLdFeatureFlag && checkIsRiyal(currency);
  const saudiRiyalCheck = () => {
    return saudiCurrencySymbol ? (
      <>
        <span>{genuinePartLink}</span>
        <span> {getRiyalFormattedPrice({
          price: `${genuineDiscountedPrice}`,
          priceWrapperClasses: 'px-1',
          isRTL,
          size: 'xxs',
        })}</span>
      </>
    ) : (
      `${genuinePartLink} ${genuineDiscountedPrice}`
    );
  };
  return (
    <CatButton
      href={remanType?.partNumber}
      variant="inline"
      label="default"
      className={cx(
        styles['cat-genuine-link'],
        isUserStoreSelected ? 'ms-lg-3' : 'ms-0'
      )}
    >			  
    {toShowGenuinePartLink
        ? saudiRiyalCheck()
        : genuinePartLink}
    </CatButton>
  );
};
export default PartGenuinePrice;
